function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("42zNJ", function(module, exports) {
    $parcel$export(module.exports, "createPayloads", ()=>$276e70905df67437$export$51b606e6d67c2231);
    var $4XKM3 = parcelRequire("4XKM3");
    var $5DPhz;
    var $lANdF;
    var $fe1wc;
    var $aOr3t;
    var $37gc9;
    var $jI6pi;
    var $bFU4G;
    var $ghWs7;
    var $bdDDw;
    var $cPbc1;
    var $a0hd6;
    var $g1eyV;
    function $276e70905df67437$var$getUfoNameOverride(interaction) {
        const { ufoName: ufoName, apdex: apdex } = interaction;
        try {
            const ufoNameOverrides = (0, (0, parcelRequire("fe1wc")).getUfoNameOverrides)();
            if (ufoNameOverrides != null) {
                const metricKey = apdex.length > 0 ? apdex[0].key : '';
                if (ufoNameOverrides[ufoName][metricKey]) return ufoNameOverrides[ufoName][metricKey];
            }
            return ufoName;
        } catch (e) {
            return ufoName;
        }
    }
    function $276e70905df67437$var$stringifyLabelStackFully(labelStack) {
        return labelStack.map((l)=>{
            if ((0, (0, parcelRequire("g1eyV")).isSegmentLabel)(l)) return `${l.name}:${l.segmentId}`;
            return l.name;
        }).join('/');
    }
    function $276e70905df67437$var$labelStackStartWith(labelStack, startWith) {
        return $276e70905df67437$var$stringifyLabelStackFully(labelStack).startsWith($276e70905df67437$var$stringifyLabelStackFully(startWith));
    }
    function $276e70905df67437$var$getEarliestLegacyStopTime(interaction, labelStack) {
        let earliestLegacyStopTime = null;
        interaction.apdex.forEach((a)=>{
            if (!a?.stopTime) return;
            if (!$276e70905df67437$var$labelStackStartWith(a.labelStack ?? [], labelStack)) return;
            if (a.stopTime > interaction.start && (earliestLegacyStopTime ?? a.stopTime) >= a.stopTime) earliestLegacyStopTime = a.stopTime;
        });
        return earliestLegacyStopTime;
    }
    function $276e70905df67437$var$getBm3EndTimeOrFallbackValue(interaction, labelStack = [], fallbackValue = interaction.end) {
        if (interaction.type === 'press') return fallbackValue;
        return $276e70905df67437$var$getEarliestLegacyStopTime(interaction, labelStack) ?? fallbackValue;
    }
    const $276e70905df67437$var$getPageVisibilityUpToTTI = (interaction)=>{
        const { start: start } = interaction;
        const bm3EndTimeOrInteractionEndTime = $276e70905df67437$var$getBm3EndTimeOrFallbackValue(interaction);
        return (0, (0, parcelRequire("37gc9")).getPageVisibilityState)(start, bm3EndTimeOrInteractionEndTime);
    };
    const $276e70905df67437$var$getPageVisibilityUpToTTAI = (interaction)=>{
        const { start: start, end: end } = interaction;
        return (0, (0, parcelRequire("37gc9")).getPageVisibilityState)(start, end);
    };
    const $276e70905df67437$var$getVisibilityStateFromPerformance = (stop)=>{
        try {
            const results = performance.getEntriesByType('visibility-state');
            if (!results || results.length === 0) return null;
            return results.reduce((acc = null, { name: name, startTime: startTime })=>{
                if (startTime > stop) return acc;
                if (acc === null && name === null) return null;
                if (acc === null) return name;
                if (acc !== name) return 'mixed';
                return acc;
            }, null);
        } catch (e) {
            return null;
        }
    };
    const $276e70905df67437$var$getMoreAccuratePageVisibilityUpToTTI = (interaction)=>{
        const old = $276e70905df67437$var$getPageVisibilityUpToTTI(interaction);
        const tti = $276e70905df67437$var$getEarliestLegacyStopTime(interaction, []);
        if (!tti) return old;
        const buffered = $276e70905df67437$var$getVisibilityStateFromPerformance(tti);
        if (!buffered) return old;
        if (buffered !== old) return 'mixed';
        return old;
    };
    const $276e70905df67437$var$getMoreAccuratePageVisibilityUpToTTAI = (interaction)=>{
        const old = $276e70905df67437$var$getPageVisibilityUpToTTAI(interaction);
        const buffered = $276e70905df67437$var$getVisibilityStateFromPerformance(interaction.end);
        if (!buffered) return old;
        if (buffered !== old) return 'mixed';
        return old;
    };
    const $276e70905df67437$var$getInteractionStatus = (interaction)=>{
        const originalInteractionStatus = interaction.abortReason ? 'ABORTED' : 'SUCCEEDED';
        const hasBm3TTI = interaction.apdex.length > 0;
        const overrideStatus = hasBm3TTI ? 'SUCCEEDED' : originalInteractionStatus;
        return {
            originalInteractionStatus: originalInteractionStatus,
            overrideStatus: overrideStatus
        };
    };
    const $276e70905df67437$var$getResourceTimings = (start, end)=>(0, parcelRequire("ghWs7")).getResourceTimings(start, end) ?? undefined;
    const $276e70905df67437$var$getBundleEvalTimings = (start)=>(0, parcelRequire("lANdF")).getBundleEvalTimings(start);
    const $276e70905df67437$var$getSSRSuccess = (type)=>type === 'page_load' ? (0, parcelRequire("cPbc1")).getSSRSuccess() : undefined;
    const $276e70905df67437$var$getSSRFeatureFlags = (type)=>type === 'page_load' ? (0, parcelRequire("cPbc1")).getSSRFeatureFlags() : undefined;
    const $276e70905df67437$var$getPaintMetrics = (type)=>{
        if (type !== 'page_load') return {};
        const metrics = {};
        performance.getEntriesByType('paint').forEach((entry)=>{
            if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
            if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
        });
        return metrics;
    };
    const $276e70905df67437$var$getVCMetrics = (interaction)=>{
        const config = (0, (0, parcelRequire("fe1wc")).getConfig)();
        if (!config?.vc?.enabled) return {};
        if (interaction.type !== 'page_load' && interaction.type !== 'transition') return {};
        const ssr = interaction.type === 'page_load' && config?.ssr ? {
            ssr: $276e70905df67437$var$getSSRDoneTimeValue(config)
        } : null;
        (0, (0, parcelRequire("bFU4G")).postInteractionLog).setVCObserverSSRConfig(ssr);
        const tti = interaction.apdex?.[0]?.stopTime;
        const prefix = 'ufo';
        const result = (0, (0, parcelRequire("a0hd6")).getVCObserver)().getVCResult({
            start: interaction.start,
            stop: interaction.end,
            tti: tti,
            prefix: prefix,
            vc: interaction.vc,
            ...ssr
        });
        (0, (0, parcelRequire("bFU4G")).postInteractionLog).setLastInteractionFinishVCResult(result);
        const VC = result?.['metrics:vc'];
        if (!VC || !result?.[`${prefix}:vc:clean`]) return result;
        const interactionStatus = $276e70905df67437$var$getInteractionStatus(interaction);
        const pageVisibilityUpToTTAI = $276e70905df67437$var$getPageVisibilityUpToTTAI(interaction);
        if (interactionStatus.originalInteractionStatus !== 'SUCCEEDED' || pageVisibilityUpToTTAI !== 'visible') return result;
        return {
            ...result,
            'metric:vc90': VC['90']
        };
    };
    const $276e70905df67437$var$getNavigationMetrics = (type)=>{
        if (type !== 'page_load') return {};
        const entries = performance.getEntriesByType('navigation');
        if (entries.length === 0) return {};
        const navigation = entries[0];
        const metrics = {
            redirectStart: Math.round(navigation.redirectStart),
            redirectEnd: Math.round(navigation.redirectEnd),
            fetchStart: Math.round(navigation.fetchStart),
            domainLookupStart: Math.round(navigation.domainLookupStart),
            domainLookupEnd: Math.round(navigation.domainLookupEnd),
            connectStart: Math.round(navigation.connectStart),
            connectEnd: Math.round(navigation.connectEnd),
            secureConnectionStart: Math.round(navigation.secureConnectionStart),
            requestStart: Math.round(navigation.requestStart),
            responseStart: Math.round(navigation.responseStart),
            responseEnd: Math.round(navigation.responseEnd),
            encodedBodySize: Math.round(navigation.encodedBodySize),
            decodedBodySize: Math.round(navigation.decodedBodySize),
            transferSize: Math.round(navigation.transferSize),
            redirectCount: navigation.redirectCount,
            type: navigation.type,
            unloadEventEnd: Math.round(navigation.unloadEventEnd),
            unloadEventStart: Math.round(navigation.unloadEventStart),
            workerStart: Math.round(navigation.workerStart),
            nextHopProtocol: navigation.nextHopProtocol
        };
        return {
            'metrics:navigation': metrics
        };
    };
    const $276e70905df67437$var$getPPSMetrics = (interaction)=>{
        const { start: start, end: end } = interaction;
        const config = (0, (0, parcelRequire("fe1wc")).getConfig)();
        const interactionStatus = $276e70905df67437$var$getInteractionStatus(interaction);
        const pageVisibilityUpToTTAI = $276e70905df67437$var$getPageVisibilityUpToTTAI(interaction);
        const tti = interaction.apdex?.[0]?.stopTime;
        const ttai = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
        const PPSMetricsAtTTI = tti !== undefined ? (0, (0, parcelRequire("5DPhz")).getLighthouseMetrics)({
            start: start,
            stop: tti
        }) : null;
        const PPSMetricsAtTTAI = ttai !== undefined ? (0, (0, parcelRequire("5DPhz")).getLighthouseMetrics)({
            start: start,
            stop: interaction.end
        }) : null;
        if (config?.shouldCalculateLighthouseMetricsFromTTAI && PPSMetricsAtTTAI !== null) return PPSMetricsAtTTAI;
        if (PPSMetricsAtTTI !== null) return {
            ...PPSMetricsAtTTI,
            'metrics@ttai': PPSMetricsAtTTAI
        };
        return {};
    };
    function $276e70905df67437$var$getSSRProperties(type) {
        return {
            'ssr:success': $276e70905df67437$var$getSSRSuccess(type),
            'ssr:featureFlags': $276e70905df67437$var$getSSRFeatureFlags(type)
        };
    }
    const $276e70905df67437$var$getBrowserMetadata = ()=>{
        const data = {};
        const now = new Date();
        data['event:localHour'] = now.getHours();
        data['event:localDayOfWeek'] = now.getDay();
        data['event:localTimezoneOffset'] = now.getTimezoneOffset();
        if (navigator.userAgent != null) {
            const browser = (0, ($parcel$interopDefault($4XKM3))).getParser(navigator.userAgent);
            data['event:browser:name'] = browser.getBrowserName();
            data['event:browser:version'] = browser.getBrowserVersion();
        }
        if (navigator.hardwareConcurrency != null) data['event:cpus'] = navigator.hardwareConcurrency;
        if (navigator.deviceMemory != null) data['event:memory'] = navigator.deviceMemory;
        if (navigator.connection != null) {
            data['event:network:effectiveType'] = navigator.connection.effectiveType;
            data['event:network:rtt'] = navigator.connection.rtt;
            data['event:network:downlink'] = navigator.connection.downlink;
        }
        return data;
    };
    const $276e70905df67437$var$getTracingContextData = (interaction)=>{
        const { trace: trace, start: start } = interaction;
        let tracingContextData = {};
        if (trace) tracingContextData = {
            'ufo:tracingContext': {
                'X-B3-TraceId': trace.traceId,
                'X-B3-SpanId': trace.spanId,
                browserTimeOrigin: +(performance.timeOrigin + start).toFixed(2)
            }
        };
        return tracingContextData;
    };
    function $276e70905df67437$var$optimizeLabelStack(labelStack) {
        return labelStack.map((ls)=>({
                n: ls.name,
                ...ls.segmentId ? {
                    s: ls.segmentId
                } : {}
            }));
    }
    function $276e70905df67437$var$optimizeCustomData(interaction) {
        const { customData: customData, legacyMetrics: legacyMetrics } = interaction;
        const customDataMap = customData.reduce((result, { labelStack: labelStack, data: data })=>{
            const label = $276e70905df67437$var$stringifyLabelStackFully(labelStack);
            const value = result.get(label)?.data ?? {};
            result.set(label, {
                labelStack: $276e70905df67437$var$optimizeLabelStack(labelStack),
                data: Object.assign(value, data)
            });
            return result;
        }, new Map());
        if (legacyMetrics) {
            const legacyMetricsFiltered = legacyMetrics.filter((item)=>item.type === 'PAGE_LOAD').reduce((result, currentValue)=>{
                for (const [key, value] of Object.entries(currentValue.custom || {})){
                    const label = $276e70905df67437$var$stringifyLabelStackFully([]);
                    const labelValue = result.get(label)?.data ?? {};
                    result.set(label, {
                        labelStack: $276e70905df67437$var$optimizeLabelStack([]),
                        data: Object.assign(labelValue, {
                            [key]: value
                        })
                    });
                }
                return result;
            }, new Map());
            return [
                ...customDataMap.values(),
                ...legacyMetricsFiltered.values()
            ];
        }
        return [
            ...customDataMap.values()
        ];
    }
    function $276e70905df67437$var$optimizeReactProfilerTimings(reactProfilerTimings, interactionStart) {
        const reactProfilerTimingsMap = reactProfilerTimings.reduce((result, { labelStack: labelStack, startTime: startTime, commitTime: commitTime, actualDuration: actualDuration, type: type })=>{
            if (labelStack && startTime >= interactionStart) {
                const label = $276e70905df67437$var$stringifyLabelStackFully(labelStack);
                const start = Math.round(startTime);
                const end = Math.round(commitTime);
                const timing = result.get(label) || {
                    labelStack: $276e70905df67437$var$optimizeLabelStack(labelStack),
                    startTime: start,
                    endTime: end,
                    mountCount: 0,
                    rerenderCount: 0,
                    renderDuration: 0
                };
                if (start < timing.startTime) timing.startTime = start;
                if (end > timing.endTime) timing.endTime = end;
                if (type === 'mount') timing.mountCount += 1;
                if (type === 'update') timing.rerenderCount += 1;
                timing.renderDuration += Math.round(actualDuration);
                result.set(label, timing);
            }
            return result;
        }, new Map());
        return [
            ...reactProfilerTimingsMap.values()
        ];
    }
    function $276e70905df67437$var$optimizeRedirects(redirects, interactionStart) {
        let lastRedirectTime = interactionStart;
        const updatedRedirects = redirects.sort((a, b)=>a.time - b.time).reduce((result, redirect)=>{
            const { fromInteractionName: fromInteractionName, time: time } = redirect;
            if (lastRedirectTime >= interactionStart) result.push({
                labelStack: [
                    {
                        n: fromInteractionName
                    }
                ],
                startTime: Math.round(lastRedirectTime),
                endTime: Math.round(time)
            });
            lastRedirectTime = time;
            return result;
        }, []);
        return updatedRedirects;
    }
    function $276e70905df67437$var$optimizeHoldInfo(holdInfo, interactionStart) {
        const holdInfoMap = holdInfo.reduce((result, hold)=>{
            const { labelStack: labelStack, name: name, start: start, end: end, ignoreOnSubmit: ignoreOnSubmit } = hold;
            if (labelStack && !ignoreOnSubmit && start >= interactionStart) {
                const label = $276e70905df67437$var$stringifyLabelStackFully([
                    ...labelStack,
                    {
                        name: name
                    }
                ]);
                const startTime = Math.round(start);
                const endTime = Math.round(end);
                const timing = result.get(label) || {
                    labelStack: $276e70905df67437$var$optimizeLabelStack([
                        ...labelStack,
                        {
                            name: name
                        }
                    ]),
                    startTime: startTime,
                    endTime: endTime
                };
                if (startTime < timing.startTime) timing.startTime = startTime;
                if (endTime > timing.endTime) timing.endTime = endTime;
                result.set(label, timing);
            }
            return result;
        }, new Map());
        return [
            ...holdInfoMap.values()
        ];
    }
    function $276e70905df67437$var$optimizeSpans(spans, interactionStart) {
        const updatedSpans = spans.reduce((result, span)=>{
            const { labelStack: labelStack, type: type, name: name, start: start, end: end } = span;
            if (labelStack && start >= interactionStart) result.push({
                labelStack: $276e70905df67437$var$optimizeLabelStack([
                    ...labelStack,
                    {
                        name: name
                    }
                ]),
                startTime: Math.round(start),
                endTime: Math.round(end),
                type: type
            });
            return result;
        }, []);
        return updatedSpans;
    }
    function $276e70905df67437$var$optimizeRequestInfo(requestInfo, interactionStart) {
        const updatedRequestInfo = requestInfo.reduce((result, reqInfo)=>{
            const { labelStack: labelStack, name: name, start: start, end: end, networkStart: networkStart, networkComplete: networkComplete } = reqInfo;
            const startTime = networkStart ?? start;
            const endTime = networkComplete ?? end;
            if (labelStack && start >= interactionStart && endTime) result.push({
                labelStack: $276e70905df67437$var$optimizeLabelStack([
                    ...labelStack,
                    {
                        name: name
                    }
                ]),
                startTime: Math.round(startTime),
                endTime: Math.round(endTime)
            });
            return result;
        }, []);
        return updatedRequestInfo;
    }
    function $276e70905df67437$var$optimizeCustomTimings(customTimings, interactionStart) {
        const updatedCustomTimings = customTimings.reduce((result, item)=>{
            Object.keys(item.data).forEach((key)=>{
                if (item.data[key].startTime >= interactionStart) result.push({
                    labelStack: [
                        {
                            n: key
                        }
                    ],
                    startTime: Math.round(item.data[key].startTime),
                    endTime: Math.round(item.data[key].endTime)
                });
            });
            return result;
        }, []);
        return updatedCustomTimings;
    }
    function $276e70905df67437$var$optimizeMarks(marks) {
        return marks.map(({ labelStack: labelStack, time: time, ...others })=>({
                ...others,
                labelStack: labelStack && $276e70905df67437$var$optimizeLabelStack(labelStack),
                time: Math.round(time)
            }));
    }
    function $276e70905df67437$var$optimizeApdex(apdex) {
        return apdex.map(({ stopTime: stopTime, labelStack: labelStack, ...others })=>({
                ...others,
                stopTime: Math.round(stopTime),
                ...labelStack ? {
                    labelStack: $276e70905df67437$var$optimizeLabelStack(labelStack)
                } : {}
            }));
    }
    function $276e70905df67437$var$objectToArray(obj = {}) {
        return Object.keys(obj).reduce((result, key)=>{
            result.push({
                label: key,
                data: obj[key]
            });
            return result;
        }, []);
    }
    function $276e70905df67437$var$getBM3SubmetricsTimings(submetrics) {
        if (!submetrics) return null;
        const submetricsTimings = submetrics.filter((item)=>{
            return typeof item.stop === 'number' && !!item.key && typeof item.start === 'number';
        }).map((item)=>{
            let childSubmetrics;
            const newKey = `include/${item.key}`;
            if (item.submetrics) childSubmetrics = $276e70905df67437$var$getBM3SubmetricsTimings(item.submetrics);
            return {
                [newKey]: {
                    endTime: item.stop - item.start,
                    startTime: item.start
                },
                ...childSubmetrics ? childSubmetrics : {}
            };
        });
        return submetricsTimings;
    }
    function $276e70905df67437$var$getBm3TrackerTimings(interaction) {
        const interactionLegacyMetrics = interaction.legacyMetrics;
        if (!interactionLegacyMetrics) return {};
        const legacyMetrics = interactionLegacyMetrics.map((item)=>{
            return {
                key: item.key,
                startTime: item.start,
                stopTime: item.stop,
                type: item.config?.type,
                reactUFOName: item.config?.reactUFOName,
                fmp: item.marks?.['fmp'] || item.stop,
                source: 'bm3',
                timings: (0, (0, parcelRequire("aOr3t")).getBm3Timings)(item.marks, item.config.timings),
                submetrics: $276e70905df67437$var$getBM3SubmetricsTimings(item.submetrics),
                pageVisibleState: item.pageVisibleState
            };
        }).filter((item)=>!!item.type);
        return {
            legacyMetrics: legacyMetrics
        };
    }
    function $276e70905df67437$var$getSSRDoneTimeValue(config) {
        return config?.ssr?.getSSRDoneTime ? config?.ssr?.getSSRDoneTime() : (0, parcelRequire("cPbc1")).getSSRDoneTime();
    }
    function $276e70905df67437$var$getPayloadSize(payload) {
        return Math.round(new TextEncoder().encode(JSON.stringify(payload)).length / 1024);
    }
    function $276e70905df67437$var$createInteractionMetricsPayload(interaction, interactionId) {
        const interactionPayloadStart = performance.now();
        const config = (0, (0, parcelRequire("fe1wc")).getConfig)();
        if (!config) throw Error('UFO Configuration not provided');
        const { end: end, start: start, ufoName: ufoName, knownSegments: knownSegments, rate: rate, type: type, abortReason: abortReason, routeName: routeName, featureFlags: featureFlags, previousInteractionName: previousInteractionName, isPreviousInteractionAborted: isPreviousInteractionAborted, abortedByInteractionName: abortedByInteractionName } = interaction;
        const pageVisibilityAtTTI = $276e70905df67437$var$getPageVisibilityUpToTTI(interaction);
        const pageVisibilityAtTTAI = $276e70905df67437$var$getPageVisibilityUpToTTAI(interaction);
        const segments = config.killswitchNestedSegments ? [] : knownSegments;
        const isDetailedPayload = pageVisibilityAtTTAI === 'visible';
        const isPageLoad = type === 'page_load';
        const calculatePageVisibilityFromTheStartOfPageLoad = config.enableBetterPageVisibilityApi && isPageLoad;
        const moreAccuratePageVisibilityAtTTI = calculatePageVisibilityFromTheStartOfPageLoad ? $276e70905df67437$var$getMoreAccuratePageVisibilityUpToTTI(interaction) : null;
        const moreAccuratePageVisibilityAtTTAI = calculatePageVisibilityFromTheStartOfPageLoad ? $276e70905df67437$var$getMoreAccuratePageVisibilityUpToTTAI(interaction) : null;
        const labelStack = interaction.labelStack ? {
            labelStack: $276e70905df67437$var$optimizeLabelStack(interaction.labelStack)
        } : {};
        const getPageLoadInteractionMetrics = ()=>{
            if (!isPageLoad) return {};
            const config = (0, (0, parcelRequire("fe1wc")).getConfig)();
            const SSRDoneTimeValue = $276e70905df67437$var$getSSRDoneTimeValue(config);
            const SSRDoneTime = SSRDoneTimeValue !== undefined ? {
                SSRDoneTime: Math.round(SSRDoneTimeValue)
            } : {};
            return {
                ...SSRDoneTime,
                isBM3ConfigSSRDoneAsFmp: interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp,
                isUFOConfigSSRDoneAsFmp: interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp || !!config?.ssr?.getSSRDoneTime
            };
        };
        const getDetailedInteractionMetrics = ()=>{
            if (window.__UFO_COMPACT_PAYLOAD__ || !isDetailedPayload) return {};
            const spans = [
                ...interaction.spans,
                ...(0, (0, parcelRequire("bFU4G")).interactionSpans)
            ];
            (0, (0, parcelRequire("bFU4G")).interactionSpans).length = 0;
            return {
                errors: interaction.errors.map(({ labelStack: labelStack, ...others })=>({
                        ...others,
                        labelStack: labelStack && $276e70905df67437$var$optimizeLabelStack(labelStack)
                    })),
                holdActive: [
                    ...interaction.holdActive.values()
                ],
                redirects: $276e70905df67437$var$optimizeRedirects(interaction.redirects, start),
                holdInfo: $276e70905df67437$var$optimizeHoldInfo(interaction.holdInfo, start),
                spans: $276e70905df67437$var$optimizeSpans(spans, start),
                requestInfo: $276e70905df67437$var$optimizeRequestInfo(interaction.requestInfo, start),
                customTimings: $276e70905df67437$var$optimizeCustomTimings(interaction.customTimings, start),
                bundleEvalTimings: $276e70905df67437$var$objectToArray($276e70905df67437$var$getBundleEvalTimings(start)),
                resourceTimings: $276e70905df67437$var$objectToArray($276e70905df67437$var$getResourceTimings(start, end))
            };
        };
        const getPageLoadDetailedInteractionMetrics = ()=>{
            if (!isPageLoad || !isDetailedPayload) return {};
            const config = (0, (0, parcelRequire("fe1wc")).getConfig)();
            return {
                initialPageLoadExtraTimings: $276e70905df67437$var$objectToArray((0, parcelRequire("jI6pi")).getTimings()),
                SSRTimings: config?.ssr?.getSSRTimings ? config.ssr.getSSRTimings() : $276e70905df67437$var$objectToArray((0, parcelRequire("cPbc1")).getSSRTimings())
            };
        };
        const newUFOName = (0, (0, parcelRequire("g1eyV")).sanitizeUfoName)(ufoName);
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            eventType: 'operational',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: {
                    'event:hostname': window.location?.hostname || 'unknown',
                    'event:product': config.product,
                    'event:schema': '1.0.0',
                    'event:sizeInKb': 0,
                    'event:source': {
                        name: 'react-ufo/web',
                        version: (0, $2b15795c8a6ffa44$export$4cbfa0cbc1d9a512),
                        payloadSource: 'platform'
                    },
                    'event:region': config.region || 'unknown',
                    'experience:key': 'custom.interaction-metrics',
                    'experience:name': newUFOName,
                    ...$276e70905df67437$var$getBrowserMetadata(),
                    ...$276e70905df67437$var$getSSRProperties(type),
                    ...$276e70905df67437$var$getPPSMetrics(interaction),
                    ...$276e70905df67437$var$getPaintMetrics(type),
                    ...$276e70905df67437$var$getNavigationMetrics(type),
                    ...$276e70905df67437$var$getVCMetrics(interaction),
                    ...config.additionalPayloadData?.(interaction),
                    ...$276e70905df67437$var$getTracingContextData(interaction),
                    interactionMetrics: {
                        namePrefix: config.namePrefix || '',
                        segmentPrefix: config.segmentPrefix || '',
                        interactionId: interactionId,
                        pageVisibilityAtTTI: pageVisibilityAtTTI,
                        pageVisibilityAtTTAI: pageVisibilityAtTTAI,
                        experimental__pageVisibilityAtTTI: moreAccuratePageVisibilityAtTTI,
                        experimental__pageVisibilityAtTTAI: moreAccuratePageVisibilityAtTTAI,
                        rate: rate,
                        routeName: routeName,
                        type: type,
                        abortReason: abortReason,
                        featureFlags: featureFlags,
                        previousInteractionName: previousInteractionName,
                        isPreviousInteractionAborted: isPreviousInteractionAborted,
                        abortedByInteractionName: abortedByInteractionName,
                        apdex: $276e70905df67437$var$optimizeApdex(interaction.apdex),
                        end: Math.round(end),
                        start: Math.round(start),
                        segments: segments.map(({ labelStack: labelStack, ...others })=>({
                                ...others,
                                labelStack: $276e70905df67437$var$optimizeLabelStack(labelStack)
                            })),
                        marks: $276e70905df67437$var$optimizeMarks(interaction.marks),
                        customData: $276e70905df67437$var$optimizeCustomData(interaction),
                        reactProfilerTimings: $276e70905df67437$var$optimizeReactProfilerTimings(interaction.reactProfilerTimings, start),
                        ...labelStack,
                        ...getPageLoadInteractionMetrics(),
                        ...getDetailedInteractionMetrics(),
                        ...getPageLoadDetailedInteractionMetrics(),
                        ...$276e70905df67437$var$getBm3TrackerTimings(interaction)
                    },
                    'ufo:payloadTime': (0, (0, parcelRequire("bdDDw")).roundEpsilon)(performance.now() - interactionPayloadStart)
                }
            }
        };
        payload.attributes.properties['event:sizeInKb'] = $276e70905df67437$var$getPayloadSize(payload.attributes.properties);
        return payload;
    }
    function $276e70905df67437$export$51b606e6d67c2231(interactionId, interaction) {
        const ufoNameOverride = $276e70905df67437$var$getUfoNameOverride(interaction);
        const modifiedInteraction = {
            ...interaction,
            ufoName: ufoNameOverride
        };
        const interactionMetricsPayload = $276e70905df67437$var$createInteractionMetricsPayload(modifiedInteraction, interactionId);
        return [
            interactionMetricsPayload
        ];
    }
});
const $2b15795c8a6ffa44$export$4cbfa0cbc1d9a512 = '1.0.1';
parcelRegister("aOr3t", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$a3e67858f0c2f8da$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("bFU4G")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("ghWs7", function(module, exports) {
    $parcel$export(module.exports, "getResourceTimings", ()=>$76e1954f833c731a$export$9eebb59359c2e9e5);
    var $fe1wc;
    var $bdDDw;
    var $3vLAR;
    var $8aEFN;
    const $76e1954f833c731a$var$cacheableTypes = [
        'script',
        'link'
    ];
    const $76e1954f833c731a$var$resourceTypes = [
        'fetch',
        'xmlhttprequest'
    ];
    const $76e1954f833c731a$var$CACHE_NETWORK = 'network';
    const $76e1954f833c731a$var$CACHE_MEMORY = 'memory';
    const $76e1954f833c731a$var$CACHE_DISK = 'disk';
    const $76e1954f833c731a$var$calculateTransferType = (type, duration, size)=>{
        if (!$76e1954f833c731a$var$cacheableTypes.includes(type)) return $76e1954f833c731a$var$CACHE_NETWORK;
        if ((size === undefined || size === 0) && duration === 0) return $76e1954f833c731a$var$CACHE_MEMORY;
        if (size === 0 && duration > 0) return $76e1954f833c731a$var$CACHE_DISK;
        if (size === undefined) return null;
        return $76e1954f833c731a$var$CACHE_NETWORK;
    };
    const $76e1954f833c731a$var$getWindowObject = ()=>typeof window !== 'undefined' && !!window ? window : undefined;
    const $76e1954f833c731a$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>!$76e1954f833c731a$var$cacheableTypes.includes(type) || url.includes('localhost') || !!$76e1954f833c731a$var$getWindowObject() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
    const $76e1954f833c731a$var$getReportedInitiatorTypes = (xhrEnabled)=>{
        const ufoConfig = (0, (0, parcelRequire("fe1wc")).getConfig)();
        if (!ufoConfig?.allowedResources) {
            if (xhrEnabled) return [
                'script',
                'link',
                'fetch',
                'xmlhttprequest'
            ];
            return [
                'script',
                'link',
                'fetch'
            ];
        }
        return ufoConfig.allowedResources;
    };
    const $76e1954f833c731a$var$evaluateAccessToResourceTimings = (url, entry)=>!(entry.responseStart === 0 && entry.startTime > entry.responseStart);
    const $76e1954f833c731a$var$getSizeObject = (size)=>size !== undefined ? {
            size: size
        } : null;
    const $76e1954f833c731a$var$getNetworkData = (item, eventStart, hasTimingHeaders = $76e1954f833c731a$var$evaluateAccessToResourceTimings)=>{
        const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart, requestStart: requestStart, serverTime: serverTime, networkTime: networkTime, encodedSize: encodedSize, decodedSize: decodedSize } = item;
        const ttfb = (0, (0, parcelRequire("bdDDw")).roundEpsilon)(responseStart - eventStart);
        if (!$76e1954f833c731a$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
        if ($76e1954f833c731a$var$cacheableTypes.includes(initiatorType)) {
            const transferType = $76e1954f833c731a$var$calculateTransferType(initiatorType, duration, transferSize);
            return {
                ttfb: ttfb,
                transferType: transferType,
                serverTime: serverTime,
                networkTime: networkTime,
                encodedSize: encodedSize,
                decodedSize: decodedSize,
                ...$76e1954f833c731a$var$getSizeObject(transferSize)
            };
        }
        return {
            ttfb: ttfb,
            serverTime: serverTime,
            networkTime: networkTime,
            requestStart: requestStart,
            ...$76e1954f833c731a$var$getSizeObject(transferSize)
        };
    };
    const $76e1954f833c731a$export$9eebb59359c2e9e5 = (interactionStart, interactionEnd)=>{
        const resourceTiming = {};
        if (interactionStart === null) return resourceTiming;
        const resources = (0, (0, parcelRequire("8aEFN")).filterResourceTimings)(interactionStart, interactionEnd);
        if (!resources?.length) return resourceTiming;
        const { xhrFilter: xhrFilter, sanitiseEndpoints: sanitiseEndpoints, mapResources: mapResources, hasTimingHeaders: hasTimingHeaders } = (0, (0, parcelRequire("3vLAR")).getConfig)();
        const reportedInitiatorTypes = $76e1954f833c731a$var$getReportedInitiatorTypes(!!xhrFilter);
        resources.forEach((item)=>{
            if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
            const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
            if (!name) return;
            if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
            const url = $76e1954f833c731a$var$resourceTypes.includes(initiatorType) ? sanitiseEndpoints(name) : mapResources(name);
            if (!url) return;
            if (resourceTiming[url]) {
                resourceTiming[url].count = (resourceTiming[url].count || 1) + 1;
                return;
            }
            resourceTiming[url] = {
                startTime: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(startTime - interactionStart),
                duration: (0, (0, parcelRequire("bdDDw")).roundEpsilon)(duration),
                workerStart: Math.max((0, (0, parcelRequire("bdDDw")).roundEpsilon)(workerStart - interactionStart), 0),
                fetchStart: Math.max((0, (0, parcelRequire("bdDDw")).roundEpsilon)(fetchStart - interactionStart), 0),
                type: initiatorType,
                ...$76e1954f833c731a$var$getNetworkData(item, interactionStart, hasTimingHeaders)
            };
        });
        return resourceTiming;
    };
});
parcelRegister("g1eyV", function(module, exports) {
    $parcel$export(module.exports, "sanitizeUfoName", ()=>$f62d411f1679e76e$export$e08487ea3ae92adb);
    $parcel$export(module.exports, "isSegmentLabel", ()=>$f62d411f1679e76e$export$1adbaf5c2363e4ae);
    const $f62d411f1679e76e$export$e08487ea3ae92adb = (name)=>{
        return name.replace(/_/g, '-');
    };
    function $f62d411f1679e76e$export$1adbaf5c2363e4ae(obj) {
        return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
    }
});
